module.exports = __webpack_public_path__ + "static/media/tutors-1.b21020fc.png";